class FiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector("form").addEventListener(
      "input",
      this.debouncedOnSubmit.bind(this)
    );

    const filterWrapper = this.querySelector("#FiltersWrapperDesktop");
    if (filterWrapper) filterWrapper.addEventListener("keyup", onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FiltersForm.searchParamsInitial;
      if (searchParams === FiltersForm.searchParamsPrev) return;
      FiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FiltersForm.searchParamsPrev = searchParams;
    const sections = FiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FiltersForm.filterData.some(filterDataUrl)
        ? FiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FiltersForm.filterData = [...FiltersForm.filterData, { html, url }];
        FiltersForm.renderFilters(html, event);
        FiltersForm.renderProductGridContainer(html);
        FiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FiltersForm.filterData.find(filterDataUrl).html;
    FiltersForm.renderFilters(html, event);
    FiltersForm.renderProductGridContainer(html);
    FiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount").innerHTML;
    const container = document.getElementById("ProductCount");
    container.innerHTML = count;
    container.classList.remove("loading");
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const FilterDetailsElements = parsedHTML.querySelectorAll(
      "#FiltersForm .js-filter"
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const filtersToRender = Array.from(FilterDetailsElements).filter(
      (element) => !matchesIndex(element)
    );
    const countsToRender = Array.from(FilterDetailsElements).find(matchesIndex);

    filtersToRender.forEach((element) => {
      document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`
      ).innerHTML = element.innerHTML;
    });

    FiltersForm.renderActiveFilters(parsedHTML);

    // if (countsToRender)
    //   FiltersForm.renderCounts(
    //     countsToRender,
    //     event.target.closest(".js-filter")
    //   );
  }

  static renderActiveFilters(html) {
    const activeFilterElementSelectors = [".active-filters"];

    activeFilterElementSelectors.forEach((selector) => {
      const activeFilterElement = html.querySelector(selector);
      if (!activeFilterElement) return;
      document.querySelector(selector).innerHTML =
        activeFilterElement.innerHTML;
    });
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest("form"));
    const searchParams = new URLSearchParams(formData).toString();
    FiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1
          );
    FiltersForm.renderPage(url);
  }
}

FiltersForm.filterData = [];
FiltersForm.searchParamsInitial = window.location.search.slice(1);
FiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("filters-form", FiltersForm);
FiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("change", this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const inputValueformat = input.value.replace(/\D/g, "");
    const stringnumber = parseInt(inputValueformat);
    const formatCountryValue = stringnumber.toLocaleString("es-CL", {
      maximumFractionDigits: 0,
    });
    input.value = formatCountryValue;

    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class FilterRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest("filters-form") || document.querySelector("filters-form");
    form.onActiveFilterClick(event);
  }
}

customElements.define("filter-remove", FilterRemove);
